import { useEffect, useState } from "react";
import { FileUpload } from "primereact/fileupload"

const UploadInput = ({
  label,
  buttonText,
  name,
  accept,
  helperText,
  setFile,
  disabled,
  fileUrl,
}) => {
  const [fileName, setFileName] = useState(fileUrl);

  const handleFileUpload = async (event) => {
    const file = event.files[0];
    setFile(file);
    setFileName(file.name);
  };

  useEffect(() => {
    setFileName(fileUrl);
  }, [fileUrl]);

  return (
    <>
      {label && 
        <label 
          htmlFor={name} 
          className="m-0 text-gray-500 text-base"
        >
          {label}
        </label>
      }

      <FileUpload
        chooseLabel={fileName ? fileName : buttonText}
        disabled={disabled}
        mode="basic" 
        name={name}
        accept={accept}
        customUpload
        uploadHandler={handleFileUpload} 
        auto
        className="my-2"
      />

      {helperText && !fileName && (<p className="m-0 text-gray-400">{helperText}</p>)}
      {!!fileName && (<p className="m-0 text-gray-400">Arquivo selecionado.</p>)}
    </>
  )
}

export default UploadInput;